var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"app-table__cell",class:[_vm.cell.prop, _vm.cell.propType,]},[_c('div',{staticClass:"app-table__cell-content"},[_c('AppSwitch',{attrs:{"value":_vm.entity.enabled,"text":"","title":_vm.entity.enabled ? 'Активен' : 'В архиве'},on:{"input":_vm.changeStatus}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }